import React, { Dispatch, SetStateAction } from 'react';

import { MetricsItem } from '@mygpt/app';

export interface ChartContext {
  times: string[]; // X轴上的值，day | month
  timesText: string; // 选择的时间值文案
  rangeDate: string[]; // 数据的时间范围
  datas: MetricsItem[];
}

export const ChartContext = React.createContext<ChartContext>({} as ChartContext);

export const useChartDatas = () => {
  const { datas, rangeDate, times, timesText } = React.useContext(ChartContext);

  return {
    times,
    datas,
    timesText,
    rangeDate,
  };
};
